export default __webpack_public_path__ + "static/media/it.314f5cc5.svg";